(function() {
    'use strict';

    try {
        const data = window.inspirewebData || {};
        const currentCollection = data.currentCollectionHandle || "";
        const currentProduct = data.currentProductHandle || "";
        const allVideos = data.videos || [];

        let videoList = allVideos.filter(v => v && v.url);

        if (currentProduct) {
            videoList = videoList.filter(v => !v.product || v.product === currentProduct);
        } else if (currentCollection) {
            videoList = videoList.filter(v => !v.collection || v.collection === currentCollection);
        }

        const popup = document.getElementById("inspireweb-video-popup");
        if (!videoList.length) {
            if (popup) popup.style.display = "none";
            return;
        }
        if (popup) popup.style.display = "block";

        const elements = {
            miniVideo: document.getElementById("inspireweb-mini-video"),
            mainVideo: document.getElementById("inspireweb-main-video"),
            minimizedBox: document.querySelector(".inspireweb-video-minimized"),
            expandedBox: document.querySelector(".inspireweb-video-expanded"),
            closeExpanded: document.querySelector(".inspireweb-close-video"),
            closeMinimized: document.querySelector(".inspireweb-close-video-min"),
            pagination: document.querySelector(".inspireweb-pagination"),
            muteBtn: document.querySelector(".inspireweb-mute-btn"),
            muteBtnPopup: document.querySelector(".inspireweb-mute-btn-popup"),
            titleMini: document.querySelector(".inspireweb-video-title"),
            titleMax: document.querySelector(".inspireweb-video-title-max"),
            clickArea: document.querySelector(".inspireweb-video-area"),
            productCard: document.getElementById('iw-product-card')
        };

        let currentIndex = 0;
        let isMuted = true;

        // ── Proteção contra pausa externa (modal quick-add etc.) ──
        [elements.miniVideo, elements.mainVideo].forEach(function(video) {
            if (!video) return;
            video.addEventListener('pause', function() {
                if (video.__iwPausaPermitida) return;
                setTimeout(function() { video.play().catch(function(){}); }, 20);
            });
        });

        function permitirPausa(ms) {
            [elements.miniVideo, elements.mainVideo].forEach(function(v) {
                if (!v) return;
                v.__iwPausaPermitida = true;
                setTimeout(function() { v.__iwPausaPermitida = false; }, ms || 500);
            });
        }

        // ── Só um vídeo toca por vez ──────────────────────────────
        function tocarSoMini() {
            // Para o main, toca só o mini
            elements.mainVideo.__iwPausaPermitida = true;
            elements.mainVideo.pause();
            elements.mainVideo.muted = true;
            setTimeout(() => { elements.mainVideo.__iwPausaPermitida = false; }, 300);

            elements.miniVideo.muted = isMuted;
            elements.miniVideo.play().catch(() => {});
        }

        function tocarSoMain() {
            // Para o mini, toca só o main
            elements.miniVideo.__iwPausaPermitida = true;
            elements.miniVideo.pause();
            elements.miniVideo.muted = true;
            setTimeout(() => { elements.miniVideo.__iwPausaPermitida = false; }, 300);

            elements.mainVideo.muted = isMuted;
            elements.mainVideo.play().catch(() => {});
        }

        const updateProductUI = (index) => {
            const video = videoList[index];
            const card = elements.productCard;
            if (!card) return;

            if (video.product && video.prodTitle && video.prodTitle !== "") {
                document.getElementById('iw-card-img').src = video.prodImg;
                document.getElementById('iw-card-title').innerText = video.prodTitle;
                document.getElementById('iw-card-price').innerText = video.prodPrice;
                const btn = document.getElementById('iw-card-btn');
                btn.href = video.prodUrl;
                btn.onclick = (e) => { e.stopPropagation(); };
                const isCurrent = currentProduct === video.product;
                btn.style.display = (isCurrent || video.showBtn === false) ? 'none' : 'block';
                card.classList.remove('hidden');
            } else {
                card.classList.add('hidden');
            }
        };

        const setupPagination = () => {
            elements.pagination.innerHTML = "";
            videoList.forEach(() => {
                const bar = document.createElement("div");
                bar.className = "bar";
                const progress = document.createElement("div");
                progress.className = "progress";
                bar.appendChild(progress);
                elements.pagination.appendChild(bar);
            });
        };
        setupPagination();

        const getProgressBars = () => Array.from(document.querySelectorAll(".inspireweb-pagination .progress"));

        const loadVideo = (index) => {
            if (index < 0 || index >= videoList.length) return;

            currentIndex = index;
            window.inspirewebCurrentIndex = index;
            const videoData = videoList[currentIndex];

            elements.mainVideo.src = videoData.url;
            elements.miniVideo.src = videoData.url;

            const rawTitle = videoData.title || "";
            const hasTitle = rawTitle.toString().trim() !== "";

            if (elements.titleMini) {
                elements.titleMini.textContent = hasTitle ? rawTitle : "";
                elements.titleMini.style.display = hasTitle ? "" : "none";
            }
            if (elements.titleMax) {
                elements.titleMax.textContent = hasTitle ? rawTitle : "";
                elements.titleMax.classList.toggle("hidden", !hasTitle);
            }

            const likeBtn = document.querySelector('.inspireweb-like-btn');
            if (likeBtn) likeBtn.classList.toggle('is-active', !!videoData.isLiked);

            updateProductUI(currentIndex);

            const progressBars = getProgressBars();
            progressBars.forEach((bar, i) => {
                bar.style.transition = "none";
                bar.style.width = i < currentIndex ? "100%" : "0%";
            });

            try {
                elements.mainVideo.load();
                elements.miniVideo.load();

                // Toca só o que está visível
                const expandedVisivel = !elements.expandedBox.classList.contains('hidden');
                if (expandedVisivel) {
                    tocarSoMain();
                } else {
                    tocarSoMini();
                }
            } catch (e) {}
        };

        elements.mainVideo.addEventListener("timeupdate", function() {
            const allProgressBars = document.querySelectorAll(".inspireweb-pagination .progress");
            if (allProgressBars.length > 0 && this.duration > 0) {
                const percent = (this.currentTime / this.duration) * 100;
                if (allProgressBars[currentIndex]) {
                    allProgressBars[currentIndex].style.transition = "width 0.1s linear";
                    allProgressBars[currentIndex].style.width = percent + "%";
                }
                allProgressBars.forEach((bar, i) => {
                    if (i < currentIndex) bar.style.width = "100%";
                    if (i > currentIndex) bar.style.width = "0%";
                });
            }
        });

        elements.mainVideo.addEventListener("ended", () => {
            loadVideo((currentIndex + 1) % videoList.length);
        });

        elements.pagination.addEventListener("click", (e) => {
            const bar = e.target.closest(".bar");
            if (!bar) return;
            const idx = Array.from(elements.pagination.children).indexOf(bar);
            if (idx !== -1) loadVideo(idx);
        });

        // Abre expandido → para mini, toca main
        elements.minimizedBox.addEventListener("click", (e) => {
            if (e.target.closest("button")) return;
            elements.minimizedBox.classList.add("hidden");
            elements.expandedBox.classList.remove("hidden");
            elements.mainVideo.currentTime = elements.miniVideo.currentTime;
            tocarSoMain();
        });

        // Fecha expandido → para main, toca mini
        elements.closeExpanded.addEventListener("click", () => {
            elements.expandedBox.classList.add("hidden");
            elements.minimizedBox.classList.remove("hidden");
            if (elements.titleMini) elements.titleMini.style.display = "";
            elements.miniVideo.currentTime = elements.mainVideo.currentTime;
            tocarSoMini();
        });

        // Fecha tudo
        elements.closeMinimized?.addEventListener("click", (e) => {
            e.stopPropagation();
            permitirPausa(500);
            elements.minimizedBox.classList.add("hidden");
            elements.miniVideo.__iwPausaPermitida = true;
            elements.mainVideo.__iwPausaPermitida = true;
            elements.miniVideo.pause();
            elements.mainVideo.pause();
        });

        // Toggle mute — aplica só no vídeo ativo
        const toggleMute = (e) => {
            e.stopPropagation();
            isMuted = !isMuted;
            const expandedVisivel = !elements.expandedBox.classList.contains('hidden');
            if (expandedVisivel) {
                elements.mainVideo.muted = isMuted;
            } else {
                elements.miniVideo.muted = isMuted;
            }
            const icon = isMuted ? "🔇" : "🔊";
            if (elements.muteBtn) elements.muteBtn.textContent = icon;
            if (elements.muteBtnPopup) elements.muteBtnPopup.textContent = icon;
        };

        elements.muteBtnPopup?.addEventListener("click", toggleMute);
        elements.muteBtn?.addEventListener("click", toggleMute);

        elements.clickArea?.addEventListener("click", (e) => {
            if (e.target.closest("button") || e.target.closest(".inspireweb-like-container") || e.target.closest(".iw-product-card")) return;
            loadVideo((currentIndex + 1) % videoList.length);
        });

        loadVideo(0);

    } catch (err) {
        console.error("InspireWeb Video Script Error:", err);
    }
})();